// --- Common views
import PaymentCalculator from '@/views/shared/PaymentCalculator.vue';
import EmptyRouterView from '@/views/shared/EmptyRouterView2.vue';

// Sub routes
import OfferSubRoute from '@/router/mobile/e-commerce-v2/sub-routes/offer';
import CreditSubRoute from '@/router/mobile/shared/credit';
import TradeInSubRoute from '@/router/mobile/shared/trade-in';
import FinanceSubRoute from '@/router/mobile/shared/finance';

export default [
  {
    path: '',
    redirect: { path: 'payment-calculator' },
  },
  {
    path: 'payment-calculator',
    component: PaymentCalculator,
    meta: {
      headerIcon: false,
      headerStyleClasses: 'mb-0',
      updateLeadOnEnter: false,
    },
  },
  {
    path: 'offer',
    component: EmptyRouterView,
    children: OfferSubRoute,
    redirect: { path: 'offer/offer-summary-form' },
  },
  {
    path: 'credit',
    component: EmptyRouterView,
    children: CreditSubRoute,
    redirect: { path: 'credit/select-credit-range' },
  },
  {
    path: 'trade-in',
    component: EmptyRouterView,
    children: TradeInSubRoute,
    redirect: { path: 'trade-in/carfax-basic-form' },
  },
  {
    path: 'finance',
    component: EmptyRouterView,
    children: FinanceSubRoute,
    redirect: { path: 'finance/finance-intro' },
  },
];
